var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMascot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 225,
    viewBox: "0 0 144 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mascot-move"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32.2452 61.6224C46.2766 80.8021 71.2168 86.4261 71.2168 86.4261C71.2168 86.4261 73.4077 60.9536 59.3763 41.774C45.3449 22.5943 20.4047 16.9703 20.4047 16.9703C20.4047 16.9703 18.2138 42.4427 32.2452 61.6224Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M49.6824 42.8934C66.7107 59.4698 68.7905 84.9515 68.7905 84.9515C68.7905 84.9515 43.2621 83.5577 26.2338 66.9813C9.20553 50.405 7.12561 24.9232 7.12561 24.9232C7.12561 24.9232 32.6541 26.3171 49.6824 42.8934Z",
    fill: "#7199FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M63.5649 40.8506C60.3739 64.3996 74.4429 85.7469 74.4429 85.7469C74.4429 85.7469 93.6858 68.9136 96.8768 45.3646C100.068 21.8155 85.9988 0.468304 85.9988 0.468304C85.9988 0.468304 66.756 17.3015 63.5649 40.8506Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M87.2431 42.4592C88.0166 66.2108 71.8444 86.0124 71.8444 86.0124C71.8444 86.0124 54.4181 67.305 53.6446 43.5534C52.8711 19.8017 69.0433 0.00012207 69.0433 0.00012207C69.0433 0.00012207 86.4696 18.7075 87.2431 42.4592Z",
    fill: "#7199FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M72 224.313C111.765 224.313 144 192.077 144 152.313C144 112.548 111.765 80.3126 72 80.3126C32.2355 80.3126 0 112.548 0 152.313C0 192.077 32.2355 224.313 72 224.313Z",
    fill: "#7199FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M69 181.312C89.4345 181.312 106 164.747 106 144.312C106 123.878 89.4345 107.312 69 107.312C48.5655 107.312 32 123.878 32 144.312C32 164.747 48.5655 181.312 69 181.312Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Eye"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M69 156C75.6274 156 81 150.627 81 144C81 137.373 75.6274 132 69 132C62.3726 132 57 137.373 57 144C57 150.627 62.3726 156 69 156Z",
    fill: "#3F3D56"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMascot);
export default __webpack_public_path__ + "static/media/mascot.f0c1a0170ef64c146b3c5dcc71478475.svg";
export { ForwardRef as ReactComponent };